<template>
  <!-- 光储充  light-->
  <div class="applicationtype">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <div class="input-small">
          <span>名称：</span>
          <el-input v-model="searchName" clearable placeholder="请输入名称"></el-input>
        </div>
        <el-button type="primary" plain @click="search_fn" class="search-btn">查询</el-button>
        <el-button type="primary" @click="add_ed(0)" class="search-btn last-el-button">新增</el-button>
      </div>
      <div class="mytable">
        <el-table id="demo" :height="heights" stripe :data="tableData" style="width: 100%" row-key="id"
          v-loading='isMask'>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column label="策略名称" align="center" prop="a" />
          <el-table-column label="动作状态" align="center" prop="b" width="90" />
          <el-table-column label="日期模型" align="center" prop="c" width="310">
            <template slot-scope="scope">
              <span>{{scope.row.weekNo | weekNoFn}}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间定义" align="center" prop="d" width="140" />
          <el-table-column label="数据状态" align="center" prop="e" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.e?'禁用':'启用'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" prop="f" width="180" />
          <el-table-column label="操作" align="center" width="390">
            <template slot-scope="scope">
              <el-button :type="scope.row.e?'warning':'danger'" size="mini"
                @click="scope.row.e=!scope.row.e">{{scope.row.e?'启用':'禁用'}}</el-button>
              <el-button type="primary" size="mini" @click="getList">绑定</el-button>
              <el-button type="success" size="mini" @click="edit_ed(scope.row,scope.$index)">修改</el-button>
              <el-button type="danger" size="mini" @click="delFun(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 详情 -->


      <!-- 新增修改 -->
      <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' width="800" v-dialogDrag
        :visible.sync="dialogVisible" center>
        <el-form :model="temp" :rules="rules" ref="temp" class="demo-temp">
          <el-form-item label="策略名称:" prop="a">
            <el-input v-model="temp.a"></el-input>
          </el-form-item>

          <el-form-item label="控制动作:" prop="b">
            <el-radio v-model="temp.b" label="开">开</el-radio>
            <el-radio v-model="temp.b" label="合">合</el-radio>
          </el-form-item>
          <el-form-item label="日期模型:" prop="c">
            <el-radio v-model="temp.c" :label="0">周一 至 周五</el-radio>
            <el-radio v-model="temp.c" :label="1">每天</el-radio>
            <el-radio v-model="temp.c" :label="2">自定义</el-radio>
          </el-form-item>
          <el-form-item label="选择日期:" v-if="temp.c ===2">
            <div class="sel">
              <div class="sel_li" :class="{'active':e.flag}" v-for="(e,i) in zhou" :key="i" @click="e.flag = !e.flag">
                {{e.n}}</div>
            </div>
          </el-form-item>
          <el-form-item label="时间定义:" prop="d">
            <el-time-select v-model="temp.d" :picker-options="{ start: '08:30', step: '00:15', end: '18:30' }"
              placeholder="选择时间">
            </el-time-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>

      <el-drawer title="" :visible.sync="drawer" :with-header="false" :size="drawerSize">
        <div class="drawer-con">
          <div class="Files-top">
            <div class="ic-left"><span>设备列表</span></div>
            <div class="btns"></div>
          </div>
          <div class="dracaozuo" style="display:flex">
            <div class="dratable" style="width:345px;margin-top:20px">
              <el-table ref="multipleTable" :data="deviceTableData" tooltip-effect="dark" style="width: 100%"
                :height="heights+100" border @selection-change="handleSelectionChange">
                <template slot="empty">
                  <span class="noData">
                    <img src="@/assets/noData.png" alt="暂无数据">
                    <span class="text">暂无数据</span>
                  </span>
                </template>
                <el-table-column type="selection" width="44" align="center"> </el-table-column>
                <el-table-column label="设备号" prop="deviceno" width="120"> </el-table-column>
                <el-table-column prop="devicename" label="设备名称"> </el-table-column>

              </el-table>
            </div>
            <div class="dra-btns">
              <div class="left-add">添加<img src="@/assets/left.png" alt=""></div>
              <div class="del">移除<img src="@/assets/right.png" alt=""></div>
            </div>
            <div class="dratree" :style="{'width':'300px','height':`${heights+150}px`}">
              <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>

            </div>
          </div>
        </div>

      </el-drawer>
    </div>
  </div>
</template>
<script>

  //   import htmlToPdf from '@/vendor/htmlToPdf';
  import {getAllEnergyType,getAllTypeByGroup,getAppTypeByGroupId,saveEnergyType,deleteEnergyType} from "../../api/energySubType";
  import {findAllAppType,apptypeSave,apptypeDeleteById} from "../../api/application";
  import resourcesStore from '@/cache/resourcesStore.js'
  import {getReadDeviceTree} from "../../api/abbNewApi";
  import elIconBtn from '@/components/module/iconBtns.vue'
  import {parseTime} from "@/utils";
  import deviceStore from '@/cache/deviceStore.js'
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  export default {
    components: {elIconBtn,elUnitTree},
    data () {
      return {
        nowVirtualDevice: '',
        defaultProps1: {
          children: 'next',
          label: 'name'
        },
        deviceData: [],
        drawer: false,
        drawerSize: "800px",
        indexed: 0,
        zhou: [{
          n: '周一',
          flag: 0,
        },{
          n: '周二',
          flag: 0,
        },{
          n: '周三',
          flag: 0,
        },{
          n: '周四',
          flag: 0,
        },{
          n: '周五',
          flag: 0,
        },{
          n: '周六',
          flag: 0,
        },{
          n: '周日',
          flag: 0,
        },],

        tableData1: [],
        isMask: false,//遮罩层
        loading: true,
        deviceTableData: [{
          deviceno: 3,
          devicename: 'A栋101'
        },
        {
          deviceno: 11,
          devicename: 'A栋201'
        },
        {
          deviceno: 13,
          devicename: 'A栋301'
        },
        {
          deviceno: 22,
          devicename: 'A栋302'
        }],

        searchName: "",//搜索名称
        total: 0,
        detail_status: false,
        Password: '',
        temp: {},
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        heights: document.getElementById('app').clientHeight-250,
        tableData: [{
          a: '储能',
          b: '开',
          c: 2,
          d: '3',
          e: true,
          weekNo: 0,
          f: '2024-02-01 10:20:53',
        },{
          a: '充电桩',
          b: '开',
          c: 2,
          d: '3',
          e: true,
          weekNo: 0,
          f: '2024-02-01 10:20:53',
        }],

        tableDataCopy: [],
        optionsd: {},
        defaultProps: {
          children: "next",
          label: "name"
        },
        dialogVisible: false,
        rules: {
          a: [
            {required: true,message: '请输入策略名称',trigger: 'blur'}
          ],
          b: [
            {required: true,message: '请选择控制动作',trigger: 'blur'}
          ],
          c: [
            {required: true,message: '请选择日期模型',trigger: 'blur'}
          ],
          d: [
            {required: true,message: '请选择时间定义',trigger: 'blur'}
          ],
          e: [
            {required: true,message: '请输入类型名称',trigger: 'blur'}
          ],
          name: [
            {required: true,message: '请输入类型名称',trigger: 'blur'}
          ],
        },
        options: [],
        typeOptions: [],
        listData: {
          "Page": 1,
          "Rows": 10
        },
        multipleSelection: '',
        columns: [
          {
            name: "编码",
            // key: "Code",
            key: "no",
            width: 90,
            al: 'center'
          },{
            name: "类型",
            // key: "Coefficient",
            key: "entityName",
            width: 90,
            al: 'center'
          }
        ],
      };
    },
    filters: {
      weekNoFn: function(value) {
        if(value==0) {
          return '每天'
        };
        if(value) {
          var d=''
          value.split(',').map(v => {
            if(v) {
              d+=('周'+v);
            }
          })
          return d;
        }
        return '';
      },

    },

    computed: {
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      getResourcesByName () {
        return resourcesStore.getters.getResourcesByName
      },
    },
    watch: {
      'temp.appType': function(val) {
        if(val==''||!val) {
          this.typeOptions=[]
          return
        }

        getAppTypeByGroupId({'groupId': val}).then(res => {
          if(res.code==200) {
            this.typeOptions=res.data
          }
        })
      },
      dialogVisible: function(val) {
        if(!val) {
          this.temp={}
        }
      },
      searchName (val) {
        if(val=='') {
          this.loading=true
          setTimeout(() => {
            this.loading=false
          },1000);
          this.deviceTableData=this.deviceTableDataCopy
        }
      },
    },
    mounted () {

      this.getList()
    },
    methods: {
      handleSelectionChange (val) {
        this.multipleSelection=val;
      },
      checkFun (val) {
        this.quxuanFlag=false
        this.nowVirtualDevice=val

      },
      //输入关键字进行过滤
      filterNode (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },
      // 删除
      delFun (i) {
        this.$confirm('是否删除此数据','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData.splice(i,1)
          this.$message({showClose: true,message: '删除成功',type: 'success'});
          this.getList()
        }).catch(() => {
          // ...
        });

      },
      //搜索列表
      search_fn () {
        this.loading=true
        setTimeout(() => {
          this.loading=false
        },1000);
        this.tableData=this.tableDataCopy.filter((item) => item.a.includes(this.searchName));
      },

      //详情
      detail (v) {
        this.temp=v;
        this.detail_status=true;
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            if(this.temp.c===0) {
              this.temp.weekNo='1,2,3,4,5';
            }
            if(this.temp.c===1) {
              this.temp.weekNo='0';
            }
            if(this.temp.c===2) {
              var d=[];
              this.zhou.map((v,i) => {
                if(v.flag) {
                  d.push(i)
                }
              })
              this.temp.weekNo=d.join(",")
            }
            this.temp.f=parseTime(new Date(),"{y}-{m}-{d} {h}:{i}:{s}")
            this.tableData.push(this.temp)
            this.temp={}
            this.dialogVisible=false;
            this.$message({showClose: true,message: '添加成功',type: 'success'});
            this.getList()
          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed (v,l) {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.temp={
          e: 1
        };
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            if(this.temp.c===0) {
              this.temp.weekNo='1,2,3,4,5';
            }
            if(this.temp.c===1) {
              this.temp.weekNo='0';
            }
            if(this.temp.c===2) {
              var d=[];
              this.zhou.map((v,i) => {
                if(v.flag) {
                  d.push(i)
                }
              })
              this.temp.weekNo=d.join(",")
            }
            this.tableData.splice(this.indexed,1,this.temp);
            this.dialogVisible=false;
            this.$message({showClose: true,message: '修改成功',type: 'success'});
            this.getList()
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v,i) {
        this.indexed=i;
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },


      //获取列表数据
      getList () {
        this.tableDataCopy=this.tableData;
      },


    }
  };
</script>

<style lang="scss" scoped>
  .drawer-con {
    padding: 12px 20px 20px 20px;
  }

  .dra-btns {
    width: 88px;
    margin: 0px 12px;
    margin-top: 240px;

    .left-add,
    .del {
      width: 88px;
      height: 32px;
      background-color: #368ED9;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
    }

    .del {
      background-color: #ED6547;
      margin-top: 40px;
    }
  }

  .dratree {
    padding: 20px 12px 12px 12px;
    box-sizing: border-box;
    border-left: 1px solid #ccc;
  }

  .energysubarea {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background-color: #fff;
      padding: 12px 20px 20px 20px;

    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }


  }

  .sel {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .sel .sel_li {
    padding: 0 8px;
    border: 1px solid;
    border-radius: 4px;
    margin-right: 10px;
    height: 24px;
    line-height: 24px;
    cursor: pointer;
  }

  .sel .active {
    background-color: #408DFF;
    color: #fff;
  }

  .applicationtype {
    .con {
      width: 100%;
      height: 100%;
      padding: 12px 20px;
      box-sizing: border-box;
      background-color: #fff;

    }



    .mydialog {
      /deep/.el-input {
        width: 240px !important;
      }
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }



    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

  }
</style>